import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Reveal, LineMask } from "@/components/Reveal";

const BARS = [48, 74, 63, 91, 69, 43, 31];
const DAYS = ["L", "M", "M", "G", "V", "S", "D"];

const Portal = () => {
  const { t } = useLang();
  const p = t.portal;
  const d = p.dash;

  return (
    <section className="portal section-light" id="professionisti" aria-labelledby="portal-title" data-testid="portal-section">
      <div className="shell portal-shell">
        <div className="portal-copy">
          <Reveal className="section-index dark" aria-hidden="true">{p.index}</Reveal>
          <Reveal><p className="kicker dark">{p.kicker}</p></Reveal>
          <h2 id="portal-title" className="display-title dark">
            <LineMask delay={0.1}>{p.titleA}</LineMask>
            <LineMask delay={0.22}><span>{p.titleB}</span></LineMask>
          </h2>
          <Reveal delay={0.15}><p>{p.text}</p></Reveal>
          <Reveal className="portal-list" delay={0.2}>
            {p.list.map((item, i) => (
              <div key={item}><b>{String(i + 1).padStart(2, "0")}</b><span>{item}</span></div>
            ))}
          </Reveal>
        </div>

        <Reveal className="dashboard-wrap" delay={0.15}>
          <div className="dashboard" data-testid="dashboard-mockup">
            <aside className="dash-side">
              <span className="mini-mark"><i></i><i></i></span>
              <nav aria-label="Dashboard preview menu">
                {d.menu.map((m, i) => (
                  <span key={m} className={i === 0 ? "active" : ""}>▦ <b>{m}</b></span>
                ))}
              </nav>
              <div className="dash-user"><span>GM</span><p><b>Gabriele</b><small>Admin</small></p></div>
            </aside>
            <div className="dash-main">
              <div className="dash-heading">
                <div><small>{d.date}</small><h3>{d.greeting}</h3></div>
                <button type="button" aria-label={d.add}>{d.add}</button>
              </div>
              <div className="dash-stats">
                {d.stats.map(([label, value, sub]) => (
                  <div key={label}><span>{label}</span><b>{value}</b><small>{sub}</small></div>
                ))}
              </div>
              <div className="dash-grid">
                <div className="activity-chart">
                  <div className="widget-head"><b>{d.chart}</b><small>{d.chartSub}</small></div>
                  <div className="bars" aria-label={d.chart}>
                    {BARS.map((h, i) => (
                      <motion.span
                        key={i}
                        className={i === 3 ? "today" : ""}
                        style={{ "--h": `${h}%` }}
                        initial={{ scaleY: 0 }}
                        whileInView={{ scaleY: 1 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.3 + i * 0.07, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                      >
                        <i>{DAYS[i]}</i>
                      </motion.span>
                    ))}
                  </div>
                </div>
                <div className="up-next">
                  <div className="widget-head"><b>{d.upNext}</b><small>{d.today}</small></div>
                  {d.events.map(([time, name, sub]) => (
                    <div className="event" key={time}><span>{time}</span><p><b>{name}</b><small>{sub}</small></p></div>
                  ))}
                </div>
              </div>
              <div className="dash-table">
                <div className="widget-head"><b>{d.follow}</b><small>{d.seeAll}</small></div>
                {d.athletes.map((a) => (
                  <div className="athlete-row" key={a.name}>
                    <span className={`person ${a.color}`}>{a.initials}</span>
                    <p><b>{a.name}</b><small>{a.sub}</small></p>
                    <span>{a.sessions}</span>
                    <i className={a.attention ? "attention" : ""}>{a.tag}</i>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <span className="interface-label">{d.label}</span>
        </Reveal>
      </div>
    </section>
  );
};

export default Portal;
